module.exports = __webpack_public_path__ + "img/total-sessions.4733baa4.svg";